import { connect } from 'react-redux'
import { setLayoutModalInfo } from 'core/templates/actions'
import ErrorLayout from './ErrorLayout'

const mapStateToProps = state => ({
  configuration: state.configuration
})

const mapDispatchToProps = { setLayoutModalInfo }

export default connect(mapStateToProps, mapDispatchToProps)(ErrorLayout)
